import { render } from "./AccountBaseView.vue?vue&type=template&id=1b12d266"
import script from "./AccountBaseView.vue?vue&type=script&lang=js"
export * from "./AccountBaseView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__